import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import { CratesDataSourceService } from './../../core/data-sources/crates-data-source.service';
import {TaskRequestSidenavService} from '../../core/services/task-request-sidenav.service';
import { ActionService } from '../../core/services/action.service';
import { ErrorService } from '../../core/services/error.service';
import {StockService} from '../../core/services/stock.service';
import { Crate, CrateType } from '../../../models/Crate';
import { SideNavResponse } from '../../pages/stock/side-nav/SideNav';

export interface StockDetailsInterface {
  item: {
    commentsQty: number;
    createdAt: number;
    id: string;
    position: string;
    section: string;
    palletStatus: string;
    skuGroups: {
      crateId: string,
      createdAt: number
      name: string,
      packSize: number,
      quantity: number,
      sku: string,
      updatedAt: number
    }[],
    state: string,
    tagRfid: string,
    tenantId: string,
    type: string,
    updatedAt: number,
    x: number,
    y: number,
    z: number
  };
  itemDetails: {
    comments: any[],
    crate: Crate,
    invoice: any,
    levels: any[],
    pathToEntry: any[],
    position: any,
    parents?: Crate[],
    children?: Crate[]
  };
  page: number;
  isMissingPallet?: boolean;
  isExit?: boolean;
  fromPendingTask?: boolean;
}





@Component({
  selector: 'app-stock-details-modal',
  templateUrl: './stock-details-modal.component.html',
  styleUrls: ['./stock-details-modal.component.scss']
})
export class StockDetailsModalComponent implements OnInit {

  selected = new FormControl(0);

  highlightedProducts = [];

  isCommentChange = false;
  isDestinyChange = false;
  loadEventTab = false;
  exitPalletWarning: string | null = null;
  isNavigatedPallet = false;
  previousPalletData: StockDetailsInterface | null = null;
  products: {
    name: string;
    sku: string;
  }[];

  constructor(public dialogRef: MatDialogRef<StockDetailsModalComponent>,
              private sidenavService: TaskRequestSidenavService,
              @Inject(MAT_DIALOG_DATA) public data: StockDetailsInterface,
              private stockService: StockService,
              private cratesDataSourceService: CratesDataSourceService,
              private actionService: ActionService,
              private errorService: ErrorService
            ) { }

  ngOnInit(): void {
    this.parseProduct();
    this.selected.setValue(this.data.page); // TODO: use enum to validate column name and tab index
    this.highlightedProducts = this.data.item.skuGroups.map(p => p.sku);
    this.data.itemDetails.comments = this.data.itemDetails.comments.filter((comment)=> !(comment.deletedAt != 0));
    const itemDetails = this.data.itemDetails;
    this.exitPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
    this.isNavigatedPallet = false;
    this.previousPalletData = null;
  }

  close(event?) {
    if (this.isCommentChange || this.isDestinyChange || event === 'SUBMITTED') {
      this.dialogRef.close('SUBMITTED');
    } else {
      this.dialogRef.close();
    }
  }

  async openSidenav() {
    this.dialogRef.close();
    const crate = this.data.itemDetails.crate;
    const productName = crate.skuGroups[0]?.name ?? 'nome não disponível';
    const data = {
      type: 'STOCK_RELOCATE_SINGLE_PALLET',
      rfId: crate.tagRfid,
      product: productName
    };
    await this.sidenavService.toggle(data).then((res) => {
      if (res !== SideNavResponse.CLOSED) {
        this.stockService.reload();
      }
    });

  }

  onSelectedIndexChange(event) {
    this.selected.setValue(event);
    this.loadEventTab = event === 1;
  }

  async submitComment(event) {
    try {
      const payload = {
        crateId: this.data.item.id,
        stage: this.data.isExit ? 'EXIT' : this.data.item.state,
        text: event.comment,
        timestamp: Date.now()
      };
      await this.actionService.addCommentToPallet(payload);
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
      this.isCommentChange = true;
    }
  }

  async deleteComment(id) {
    try {
      await this.actionService.removePalletComment({ id });
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
      this.isCommentChange = true;
    }
  }

  async update() {
    this.data.itemDetails = await this.cratesDataSourceService.getCrateById(this.data.itemDetails.crate.id).then((r: any) => {
      r.invoice = r.crate.invoices[0];
      return r;
    });
  }

  parseProduct() {
    this.products = this.data.item.skuGroups.map(p => {
      return {
        name: p.name,
        sku: p.sku
      };
    });
  }

  onInventoryClicked(crate) {
    this.dialogRef.close({
      crate: crate,
      openPalletInventorySidenav: true
    });
  }

  async handleSetUnderAlert(crateId: string) {
    try {
      await this.actionService.setPalletUnderAlert({ crateId, deviceName: 'ADM' });
      await this.update();
      this.stockService.reload();
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  async handleUnsetUnderAlert(crateId: string) {
    try {
      await this.actionService.unsetPalletUnderAlert({ crateId, deviceName: 'ADM' });
      await this.update();
      this.stockService.reload();
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  handleOpenPalletDetails(palletData) {
    this.previousPalletData = { ...this.data };
    this.data = palletData;
    this.data.itemDetails.comments = this.data.itemDetails.comments.filter((comment)=> !(comment.deletedAt != 0));
    this.exitPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${this.data.itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
    this.isNavigatedPallet = true;
    this.selected.setValue(0);
    this.loadEventTab = false;
  }

  goBackToPreviousPallet() {
    if (this.previousPalletData) {
      this.data = this.previousPalletData;
      this.exitPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${this.data.itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
      this.selected.setValue(1);
      this.loadEventTab = true;
      this.isNavigatedPallet = false;
      this.previousPalletData = null;
    }
  }
}
